<template>
  <wo-region>
    <wo-layout>
      <wo-typography v-t="labelKey" v-wo-color.light />
    </wo-layout>
  </wo-region>
</template>

<script>
export default {
  name: 'PoEmptyState',
  props: {
    labelKey: { type: String, default: 'general.emptyState' }
  }
}
</script>
